import React, { ChangeEvent } from 'react'
import { updateDistrict } from 'shared/api/mutations'
import {
  Box,
  FormControl,
  FormControlLabel,
  TextField,
  Button,
  Checkbox,
} from '@mui/material'
import { useDistrictUpdate } from 'shared/api/district'

export default function UpdateDistrictForm({
  districtID,
}: {
  readonly districtID: string
}) {
  const { reFetchDistrict, updateData, setUpdateData } =
    useDistrictUpdate(districtID)

  const onChange = (e: ChangeEvent<HTMLInputElement>) => {
    setUpdateData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }))
  }

  const onChangeChecked = (e: ChangeEvent<HTMLInputElement>) => {
    setUpdateData((prev) => ({
      ...prev,
      [e.target.name]: e.target.checked,
    }))
  }

  const onSubmit = async (e: React.FormEvent<EventTarget>) => {
    e.preventDefault()
    try {
      await updateDistrict(updateData)
      reFetchDistrict()
    } catch {}
  }
  return (
    <div>
      <Box sx={{ maxWidth: 300, minWidth: 120 }}>
        <FormControl fullWidth className="edit-district-form-box">
          <TextField
            name="name"
            value={updateData.name}
            label="Input district name"
            variant="outlined"
            onChange={onChange}
            size="small"
          />
        </FormControl>
        <FormControlLabel
          control={
            <Checkbox
              checked={updateData.is_verified}
              onChange={onChangeChecked}
              name="is_verified"
            />
          }
          label="Is Verified"
        />
        <br />
        <br />
        <FormControl fullWidth className="edit-district-form-box">
          <Button onClick={onSubmit} variant="outlined" color="secondary">
            Submit
          </Button>
        </FormControl>
      </Box>
    </div>
  )
}
